export function getAdminHeaders() {
  const token = localStorage.getItem('admin_token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
}

export function getAdminRole() {
  try {
    const adminData = localStorage.getItem('admin_data');
    if (!adminData) return null;
    const data = JSON.parse(adminData);
    return data.role || null;
  } catch {
    return null;
  }
}

export function getPermissions() {
  try {
    const adminData = localStorage.getItem('admin_data');
    if (!adminData) return [];
    const data = JSON.parse(adminData);
    return data.permissions || [];
  } catch {
    return [];
  }
}

export function hasPermission(perm) {
  const perms = getPermissions();
  return perms.includes(perm);
}

export function canEdit() {
  return hasPermission('edicao');
}

export function isFullAdmin() {
  return hasPermission('administracao');
}
